import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    listBySection: [],
    listBySectionLoading: false,
    current: {},
    currentLoading: false
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setListBySection(state, payload) {
      state.listBySection = payload;
    },
    setListBySectionLoading(state, payload) {
      state.listBySectionLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("tutorials");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllBySection({ commit }, section) {
      commit("setListBySectionLoading", true);
      let list = await api.get("tutorials/bySection", {
        params: {
          section: section
        }
      });
      commit("setListBySection", list.data);
      commit("setListBySectionLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setCurrentLoading", true);
      let response = await api.get("tutorials/byID", {
        params: { id: id }
      });
      commit("setCurrent", response.data[0]);
      commit("setCurrentLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("tutorials", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`tutorials`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async delete({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("tutorials/delete", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    }
  },
  getters: {
    list(state) {
      let sorted = state.list.sort((a, b) => {
        return parseInt(a.number) - parseInt(b.number);
      });
      return sorted;
    },
    listLoading(state) {
      return state.listLoading;
    },
    listBySection(state) {
      return state.listBySection;
    },
    listBySectionLoading(state) {
      return state.listBySectionLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    }
  }
};
